import { render, staticRenderFns } from "./edit-outairhandleContent.vue?vue&type=template&id=28297ee4&"
import script from "./edit-outairhandleContent.vue?vue&type=script&lang=ts&"
export * from "./edit-outairhandleContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports